import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import _sfc_main$1 from "../atoms/WsTooltip.vue.es.js";
/* empty css                         */
import WsIcon from "../assets/WsIcon.vue.es.js";
import { unref, toRaw } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { defineComponent, useSlots, inject, computed, resolveComponent, openBlock, createElementBlock, createElementVNode as createBaseVNode, createVNode, withCtx, createTextVNode, createCommentVNode, mergeProps } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { toDisplayString } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _hoisted_1 = { class: "ws-radio__input-wrapper" };
const _hoisted_2 = ["id", "name", "value", "checked", "disabled"];
const _hoisted_3 = { class: "ws-radio__label" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
  key: 0,
  class: "ws-radio__description"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsRadio",
  props: {
    modelValue: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    val: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    value: {
      type: [Object, Number, String, Boolean],
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: (props) => props.large ? "lg" : "md"
    },
    color: {
      type: String,
      default: "green"
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: void 0
    },
    path: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["input", "dirty", "update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const slots = useSlots();
    const emit = __emit;
    const formDataOverride = inject("formDataOverride", null);
    const isTrue = computed(() => toRaw(props.modelValue) === toRaw(props.val));
    const onChange = () => {
      if (formDataOverride) {
        formDataOverride[props.name] = props.val;
      }
      emit("input", props.val);
      emit("update:modelValue", props.val);
      emit("dirty", props.val);
    };
    return (_ctx, _cache) => {
      var _a;
      const _component_portal_slot = resolveComponent("portal-slot");
      return openBlock(), createElementBlock("label", mergeProps({
        class: ["ws-radio", [
          __props.disable ? "disabled" : "active",
          isTrue.value ? "ws-radio--checked" : "",
          "ws-radio--color-" + __props.color,
          "ws-radio--size-" + __props.size
        ]]
      }, _ctx.$attrs), [
        createBaseVNode("span", _hoisted_1, [
          createBaseVNode("input", {
            id: __props.id,
            type: "radio",
            class: "ws-radio__native",
            name: __props.name,
            value: __props.val,
            checked: isTrue.value,
            disabled: __props.disable,
            onChange
          }, null, 40, _hoisted_2)
        ]),
        createBaseVNode("span", _hoisted_3, [
          createVNode(_component_portal_slot, {
            slot: unref(slots)["default"],
            key: "default",
            name: "default",
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"]),
          createVNode(_component_portal_slot, {
            slot: unref(slots)["label"],
            key: "label",
            name: "label",
            "component-id": _ctx.$attrs["component-id"]
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.label), 1)
            ]),
            _: 1
          }, 8, ["slot", "component-id"]),
          __props.tooltip ? (openBlock(), createElementBlock("span", _hoisted_4, [
            createVNode(WsIcon, {
              name: "info",
              class: "text-ws-navy-80"
            }),
            createVNode(_sfc_main$1, null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.tooltip), 1)
              ]),
              _: 1
            })
          ])) : createCommentVNode("", true)
        ]),
        ((_a = __props.portalSlots) == null ? void 0 : _a.includes("description")) ? (openBlock(), createElementBlock("span", _hoisted_5, [
          createVNode(_component_portal_slot, {
            slot: unref(slots)["description"],
            key: "description",
            name: "description",
            "component-id": _ctx.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsRadio.vue.es.js.map
